import { ExclamationCircleIcon, NoSymbolIcon, WrenchScrewdriverIcon } from "@heroicons/react/24/outline";
import React, { Component } from "react";

export class Clients extends Component {
    
    render() {
        const {text, width} = this.props;
        return (
            <div className='w-full flex flex-col items-center py-5'>
                <ExclamationCircleIcon width={width ? width : 150} className='text-grey-400 mb-8' />
                <p className='text-lg text-grey-400 font-medium '>
                    {text ? text : "404 Not Found"}
                </p>
            </div>
        )
    }

}